// Please put date in YYYY-MM-DD format
export const clubPhotos = [
    {
        name: "Halloween 2019",
        desc: "From left to right: Joanna, Maggie, Angel, Khandy, Heiley",
        date: "2019-10-31",
    	imgname: "halloween-2019.png",
    	credits: "Khandy",
    },
    {
        name: "Halloween 2019",
        desc: "StuyFLow's group costume. We won best group costume!",
        date: "2019-10-31",
    	imgname: "halloween_2019-1.png",
    	credits: "David Madrigal",
    },
    {
        name: "Halloween 2019",
        desc: "The Gryfiindors.",
        date: "2019-10-31",
    	imgname: "halloween-2019-2.png",
    	credits: "David Madrigal",
    },
    {
        name: "Halloween 2019",
        desc: "I like this pic. From left to right: Joanna, Khandy, Heiley, Maggie",
        date: "2019-10-31",
    	imgname: "halloween-2019-3.png",
    	credits: "Khandy",
    },
    {
        name: "Poster 2019",
        desc: "Poster advertising StuyFlow for 2019-2020",
        date: "2019-09-27",
    	imgname: "poster-2019.png",
    	credits: "yeet lmk",
    },
    {
        name: "Rockefeller Park",
        desc: "Grainy photo at Rockefeller Park. Heiley about to jump Jason. Not sure the year.",
        date: "2019-08-27",
    	imgname: "rockefeller-park.png",
    	credits: "yeet lmk",
    },
    {
        name: "Lunch",
        desc: "Lunch at KBBQ in Queens.",
        date: "2019-08-20",
    	imgname: "dinner-0.png",
    	credits: "yeet lmk",
    },
    {
        name: "Dinner",
        desc: "Birthday Dinner for Khandy, Jasmine, Chloe and Roy!",
        date: "2020-01-26",
    	imgname: "dinner-2020-0.png",
    	credits: "yeet lmk",
    },
    {
        name: "Dinner",
        desc: "Birthday Dinner for Khandy, Jasmine, Chloe and Roy!",
        date: "2020-01-26",
    	imgname: "dinner-2020-1.png",
    	credits: "yeet lmk",
    },
    {
        name: "Dinner",
        desc: "Birthday Dinner for Khandy, Jasmine, Chloe and Roy!",
        date: "2020-01-26",
    	imgname: "dinner-2020-2.png",
    	credits: "yeet lmk",
    },
    {
        name: "Club Pub Fair 2019",
        desc: "Club Pub image! From left to right: Vivian, Isabelle, Kevin, Samantha, Khandy, Steve, Maggie, Heiley, Fran, Joanna, Tiffany S., Kasey, Jasmine.",
        date: "2019-09-26",
    	imgname: "camp-stuy-2019.png",
    	credits: "yeet lmk but probs Khandy",
    },
    {
        name: "Club Pub Fair 2019",
        desc: "Sleeping Tiffany with whip. Steve got swag.",
        date: "2019-9-26",
    	imgname: "camp-stuy-2019-1.png",
    	credits: "yeet lmk",
    },
    {
        name: "StuyFlow Board '19-'20",
        desc: "The seniors of the StuyFlow board 2019-2020, minus Maggie.",
        date: "2019-12-13",
    	imgname: "board_2019-0.png",
    	credits: "Khandy",
    },
    {
        name: "StuyFlow Board '19-'20",
        desc: "StuyFlow board 2019-2020, minus Joanna.",
        date: "2019-08-30",
    	imgname: "board_2019-1.png",
    	credits: "Khandy",
    },
    {
        name: "StuyFlow Board '19-'20",
        desc: "The seniors of the StuyFlow board 2019-2020, with Maggie. Photoshop courtesy of Jasmine.",
        date: "2019-12-13",
    	imgname: "board-2019-2.png",
    	credits: "Khandy",
    },
]
